<template>
  
  <div class="ui segment animated fadeIn">

    <form class="ui form">
      <div class="fields">                
        <div class="three wide field">
          <label class="form-label">CNPJ</label>
          <span>{{ customer.formatCnpj }}</span>
        </div>
        <div class="three wide field">
          <label class="form-label">Inscrição Estadual</label>
          <span>{{ customer.ie }}</span>
        </div>    
        <div class="three wide field">
          <label class="form-label">Pessoa</label>
          <span>{{ customer.person }}</span>
        </div>
        <div class="three wide field">
          <label class="form-label">Tipo</label>
          <span>{{ customer.type }}</span>
        </div>
        <div class="four wide field">
          <label class="form-label">Contribuinte</label>
          <span>{{ customer.taxPayer }}</span>
        </div>    
      </div>
      <div class="fields">
        <div class="three wide field">
          <label class="form-label">Opt. Simples Nacional</label>
          <span>{{ customer.nationalSimple }}</span>
        </div>
        <div class="three wide field">
          <label class="form-label">Desconto SUFRAMA</label>
          <span>{{ customer.suframa }}</span>
        </div>
        <div class="three wide field">
          <label class="form-label">Reg. Esp. Tributação</label>
          <span>{{ customer.specialTax }}</span>
        </div>
        <div class="seven wide field">
          <label class="form-label">CNAE</label>
          <span>{{ customer.cnae }}</span>
        </div>
      </div>     
    </form>

  </div>

</template>

<script>

  export default {    
    props: ["customer"],
  }

</script>

